export default "__VITE_ASSET__BZ50PDqe__"